<template>
  <validation-observer ref="formObserver" v-slot="{ passes }" tag="div">
    <h2 class="bg-green-500 py-3 px-5 text-white mb-8">
      Step 6: Current Project Status
    </h2>
    <form @submit.prevent="passes(goToNextPage)">
      <div class="flex flex-wrap -mx-5 mb-4 md:mb-0">
        <d-field label="Project Status" class="w-full px-5">
          <d-select v-model="projectStandards" required expanded>
            <option value="Architectural Design">
              Architectural Design
            </option>
            <option value="Construction">
              Construction (not Woodwork)
            </option>
            <option value="Shop Drawings/Pre-fabrication">
              Shop Drawings/Pre-fabrication (Woodwork)
            </option>
            <option value="Finishing">
              Finishing
            </option>
            <option value="Installation">
              Installation
            </option>
          </d-select>
        </d-field>
        <d-field label="Woodwork Mfg." class="w-full md:1/2 px-5">
          <d-input v-model="woodworkMfg" aria-label="woodwork manufacturing" />
        </d-field>
        <d-field label="Cabinet Mfg." class="w-full md:1/2 px-5">
          <d-input v-model="cabinetMfg" aria-label="cabinet manufacturing" />
        </d-field>
        <d-field label="Door Supplier" class="w-full md:1/2 px-5">
          <d-input v-model="doorSupplier" aria-label="Door supplier" />
        </d-field>
        <d-field label="Finisher" class="w-full md:1/2 px-5">
          <d-input v-model="finisher" aria-label="finisher" />
        </d-field>
        <d-field label="Installed By" class="w-full px-5">
          <d-select v-model="installedBy" required expanded>
            <option value="Woodworker">
              Woodworker
            </option>
            <option value="General Contractor">
              General Contractor
            </option>
            <option value="Carpenter Installer">
              Carpenter Installer
            </option>
            <option value="Other">
              Other (Specify)
            </option>
          </d-select>
        </d-field>
      </div>
      <div class="flex flex-wrap justify-center md:justify-end pt-5">
        <d-btn class="mx-5" @click="goToPrevPage">
          Prev <span class="hidden sm:block sm:ml-1">Step</span>
        </d-btn>
        <d-btn type="submit" class="mx-5 md:mx-0">
          Next <span class="hidden sm:block sm:ml-1">Step</span>
        </d-btn>
      </div>
    </form>
  </validation-observer>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex';
  import { mapFields } from '@resources/scripts/utilities/field.utilities';
  import { PROJECT_CERTIFICATION_FORM } from '@resources/scripts/store/mutation-types';

  const { mapActions } = createNamespacedHelpers('projectCertificationForm');

  export default {
    parent: true,

    computed: {
      ...mapFields({
        fields: ['projectStandards', 'woodworkMfg', 'cabinetMfg', 'doorSupplier', 'finisher', 'installedBy'],
        module: 'projectCertificationForm',
        base: 'formFields',
        mutation: PROJECT_CERTIFICATION_FORM.FORM_FIELDS,
      }),
    },

    methods: {
      ...mapActions([
        'goToPrevPage',
        'goToNextPage',
      ]),
    },
  };
</script>